import React from 'react';
import './TeamBuilder.css';

const TeamBuilder = () => {
  return (
    <div className="team-builder">
      <div className="team-builder__header">
        <h2>Building Your Team</h2>
        <p>A guide to creating effective competitive Pokémon teams</p>
      </div>

      <div className="team-builder__content">
        <section className="rental-teams">
          <h3>Getting Started with Rental Teams</h3>
          <p>
            Building a competitive team from scratch can be challenging and time-consuming. 
            We recommend starting with rental teams to learn the meta and understand team synergy.
          </p>
          
          <div className="rental-resources">
            <h4>Where to Find Rental Teams:</h4>
            <div className="resource-cards">
              <div className="resource-card">
                <h5>Victory Road VGC</h5>
                <p>A trusted resource for competitive rental teams with detailed team reports and usage guides.</p>
                <a href="https://victoryroadvgc.com/rental-teams/" target="_blank" rel="noopener noreferrer">Visit Website</a>
              </div>
              
              <div className="resource-card">
                <h5>Pokémon HOME</h5>
                <p>Official platform where top players share their tournament-winning teams.</p>
                <p className="note">Access through Pokémon HOME mobile app</p>
              </div>

              <div className="resource-card">
                <h5>Twitter/X #VGC</h5>
                <p>Follow competitive players who regularly share their successful team compositions.</p>
                <p className="note">Search for #PokemonVGC or #VGC</p>
              </div>
            </div>
          </div>
        </section>

        <section className="team-building-guide">
          <h3>Team Building Fundamentals</h3>
          
          <div className="building-tips">
            <div className="tip">
              <h4>1. Core Synergy</h4>
              <ul>
                <li>Start with a strong core of 2-3 Pokémon that work well together</li>
                <li>Consider type synergies and coverage</li>
                <li>Mix offensive and defensive Pokémon</li>
              </ul>
            </div>

            <div className="tip">
              <h4>2. Role Coverage</h4>
              <ul>
                <li>Include different roles: Sweepers, Tanks, Support</li>
                <li>Have answers to common threats in the meta</li>
                <li>Consider speed control options</li>
              </ul>
            </div>

            <div className="tip">
              <h4>3. Move Coverage</h4>
              <ul>
                <li>Ensure your team can hit all types for at least neutral damage</li>
                <li>Include status moves and support options</li>
                <li>Consider coverage for popular Tera types</li>
              </ul>
            </div>

            <div className="tip">
              <h4>4. Item Distribution</h4>
              <ul>
                <li>Avoid duplicate items</li>
                <li>Match items to Pokémon roles</li>
                <li>Consider common item counters in the meta</li>
              </ul>
            </div>

            <div className="tip">
              <h4>5. Test and Refine</h4>
              <ul>
                <li>Use the Battle Stadium to test your team</li>
                <li>Keep track of common losses and adjust accordingly</li>
                <li>Don't be afraid to make changes based on performance</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="common-mistakes">
          <h3>Common Team Building Mistakes to Avoid</h3>
          <ul>
            <li>Having too many Pokémon with similar weaknesses</li>
            <li>Lacking speed control options</li>
            <li>Not having answers to common meta threats</li>
            <li>Over-relying on a single strategy</li>
            <li>Ignoring support moves in favor of all attacks</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TeamBuilder; 